module.exports = __webpack_public_path__ + "img/3.3341e243.jpg";